module.exports = __webpack_public_path__ + "static/img/logo.f689c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 97